// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getRatingsDevicesService = async (status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/device-management${query}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getRatingsDevicesService ', error);
  }
};

export const getGoogleBussinessesService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/google-business/bussinesses`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getGoogleBussinessesService ', error);
  }
};

export const getRatingsDevicesByPaginateService = async (page: number, status?: number) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.get<any>(`/v1/ratings/device-management?page=${page}&take=10${query}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getRatingsDevicesByPaginateService ', error);
  }
};

export const getRatingsDevicesBySearchService = async (param: string, status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/device-management/search/${param}${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsDevicesBySearchService ', error);
  }
};

export const createRatingsDeviceService = async (device: object, setPercentaje: any) => {
  try {
    return await http.post<any>(`/v1/ratings/device-management`, device, setPercentaje);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createRatingsDeviceService ', error);
  }
};

export const updateRatingsDeviceService = async (device: any) => {
  try {
    return await http.put<any>(`/v1/ratings/device-management/${device.id}`, device);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateRatingsDeviceService ', error);
  }
};

export const desactiveRatingsDeviceService = async (
  deviceId: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.delete<any>(
      `/v1/ratings/device-management/${deviceId}?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('desactiveRatingsDeviceService ', error);
  }
};

export const activeRatingsDeviceService = async (
  deviceId: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.patchTable<any>(
      `/v1/ratings/device-management/${deviceId}/restore?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('activeRatingsDeviceService ', error);
  }
};

export const getRatingsDeviceDetailService = async (deviceId: string) => {
  try {
    return await http.get<any>(`/v1/ratings/device-management/${deviceId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getRatingsDeviceDetailService ', error);
  }
};

export const getRatingsSurveysService = async (status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/surveys${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsSurveysService ', error);
  }
};

export const getRatingsSurveysByPaginateService = async (page: number, status?: number) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.get<any>(`/v1/ratings/surveys?page=${page}&take=10${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsSurveysByPaginateService ', error);
  }
};

export const createRatingsSurveyService = async (survey: object) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/surveys`, survey);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createRatingsSurveyService ', error);
  }
};

export const updateRatingsSurveyService = async (survey: any) => {
  try {
    return await http.put<any>(`/v1/ratings/surveys/${survey.id}`, survey);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateRatingsSurveyService ', error);
  }
};

export const deleteRatingsSurveyService = async (
  surveyId: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.delete<any>(
      `/v1/ratings/surveys/${surveyId}?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteRatingsSurveyService ', error);
  }
};

export const activeRatingsSurveyService = async (
  surveyId: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.patchTable<any>(
      `/v1/ratings/surveys/${surveyId}/restore?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('activeRatingsSurveyService ', error);
  }
};

export const getRatingsSurveyDetailService = async (surveyId: string) => {
  try {
    return await http.get<any>(`/v1/ratings/surveys/${surveyId}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsSurveyDetailService ', error);
  }
};

export const getRatingsAssignmentsService = async (status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/devices${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsAssignmentsService ', error);
  }
};

export const getRatingsAssignmentsByPaginateService = async (page: number, status?: number) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.get<any>(`/v1/ratings/devices?page=${page}&take=10${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsAssignmentsByPaginateService ', error);
  }
};

export const getRatingsAssignmentsBySearchService = async (param: string, status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/devices/search/${param}${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsAssignmentsBySearchService ', error);
  }
};

export const createRatingsAssignmentService = async (assignment: object) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/devices`, assignment);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createRatingsAssignmentService ', error);
  }
};

export const updateRatingsAssignmentService = async (assignment: any) => {
  try {
    return await http.put<any>(`/v1/ratings/devices/${assignment.id}`, assignment);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateRatingsAssignmentService ', error);
  }
};

export const deleteRatingsAssignmentService = async (
  id: string,
  value: any,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.delete<any>(`/v1/ratings/devices/${id}?param=${value}&page=${page}${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteRatingsAssignmentService ', error);
  }
};

export const activeRatingsAssignmentService = async (
  id: string,
  value: any,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.patchTable<any>(
      `/v1/ratings/devices/${id}/restore?param=${value}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('activeRatingsAssignmentService ', error);
  }
};

export const getRatingsAssignmentDetailService = async (assignmentId: string, mode?: string) => {
  try {
    const url = `/v1/ratings/devices/${assignmentId}${mode ? `?mode=${mode}` : ''}`;
    return await http.get<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsAssignmentDetailService ', error);
  }
};

export const getAvailableConfigsRatingsService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/devices/available-configs`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getAvailableConfigsRatingsService ', error);
  }
};

export const getQualificationsService = async (
  userId?: string,
  fromDate?: string,
  toDate?: string,
  reportedEvents?: string,
  status?: number,
  areaId?: string,
  locationId?: string
) => {
  try {
    let url = `/v1/ratings/qualifications`;
    const params = new URLSearchParams();
    if (userId) params.append('userId', userId);
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    if (reportedEvents) params.append('reportedEvents', reportedEvents);
    if (status !== undefined) params.append('status', status.toString());
    if (areaId) params.append('areaId', areaId);
    if (locationId) params.append('locationId', locationId);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return await http.get<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getQualificationsService ', error);
  }
};

export const getQualificationsByPaginateService = async (page: number, filters: any) => {
  try {
    let url = `/v1/ratings/qualifications`;
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('take', '10');

    if (filters?.userId) params.append('userId', filters.userId);
    if (filters?.fromDate) params.append('fromDate', filters.fromDate);
    if (filters?.toDate) params.append('toDate', filters.toDate);
    if (filters?.reportedEvents) params.append('reportedEvents', filters.reportedEvents);
    if (filters?.status !== undefined) params.append('status', filters.status.toString());
    if (filters?.areaId) params.append('areaId', filters.areaId);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return await http.get<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getQualificationsByPaginateService ', error);
  }
};

export const deleteQualificationService = async (qualificationId: string, filters: any) => {
  try {
    let url = `/v1/ratings/qualifications/${qualificationId}`;
    if (filters) {
      const params = new URLSearchParams();
      if (filters.userId) params.append('userId', filters.userId);
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);
      if (filters.reportedEvents) params.append('reportedEvents', filters.reportedEvents);
      if (filters.status !== undefined) params.append('status', filters.status.toString());
      if (filters.areaId) params.append('areaId', filters.areaId);

      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
    }
    return await http.delete<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteQualificationService ', error);
  }
};

export const restoreQualificationService = async (qualificationId: string, filters: any) => {
  try {
    let url = `/v1/ratings/qualifications/${qualificationId}/restore`;
    if (filters) {
      const params = new URLSearchParams();
      if (filters.userId) params.append('userId', filters.userId);
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);
      if (filters.reportedEvents) params.append('reportedEvents', filters.reportedEvents);
      if (filters.status !== undefined) params.append('status', filters.status.toString());
      if (filters.areaId) params.append('areaId', filters.areaId);

      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
    }
    return await http.patch<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('restoreQualificationService ', error);
  }
};

export const getAvailableUsersRatingsService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/device-management/available-users`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getAvailableUsersRatingsService ', error);
  }
};

export const getAvailableSurveysRatingsService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/device-management/available-surveys`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getAvailableSurveysRatingsService ', error);
  }
};

export const getRatingsSurveysBySearchService = async (param: string, status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/surveys/search/${param}${query}`);
  } catch (error: any) {}
};

export const getAlertRiskLevelTriggerLogService = async (id: string) => {
  try {
    return await http.get<any>(`/v1/alert-risk-level-trigger-logs/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getAlertRiskLevelTriggerLogService ', error);
  }
};

export const postAlertRiskLevelTriggerLogFollowUpService = async (id: string, payload: any) => {
  try {
    return await http.postLogin<any>(`/v1/alert-risk-level-trigger-logs/${id}/follow-ups`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('postAlertRiskLevelTriggerLogFollowUpService ', error);
  }
};

export const updateAlertRiskLevelTriggerLogService = async (id: string, payload: any) => {
  try {
    return await http.patchTable<any>(`/v1/alert-risk-level-trigger-logs/close-case/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateAlertRiskLevelTriggerLogService ', error);
  }
};

// =====================================================================
// REGLAS Y ALERTAS (RULES AND ALERTS)
// =====================================================================

export const getRulesAndAlertsPaginationService = async (page: number, status?: number) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.get<any>(`/v1/ratings/rules-and-alerts?page=${page}&take=10${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRulesAndAlertsPaginationService ', error);
  }
};

export const getRulesAndAlertsBySearchService = async (param: string, status?: number) => {
  try {
    const query = status !== undefined ? `?status=${status}` : '';
    return await http.get<any>(`/v1/ratings/rules-and-alerts/search/${param}${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRulesAndAlertsBySearchService ', error);
  }
};

export const createRulesAndAlertService = async (payload: any) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/rules-and-alerts`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createRulesAndAlertService ', error);
  }
};

export const getRulesAndAlertDetailService = async (id: string) => {
  try {
    return await http.get<any>(`/v1/ratings/rules-and-alerts/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRulesAndAlertDetailService ', error);
  }
};

export const updateRulesAndAlertService = async (id: string, payload: any) => {
  try {
    return await http.put<any>(`/v1/ratings/rules-and-alerts/${id}`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateRulesAndAlertService ', error);
  }
};

export const deleteRulesAndAlertService = async (
  id: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.delete<any>(
      `/v1/ratings/rules-and-alerts/${id}?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteRulesAndAlertService ', error);
  }
};

export const restoreRulesAndAlertService = async (
  id: string,
  param: string,
  page: number,
  status?: number
) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.patchTable<any>(
      `/v1/ratings/rules-and-alerts/${id}/restore?param=${param}&page=${page}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('restoreRulesAndAlertService ', error);
  }
};

export const getFollowConfigService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/follow-config`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getFollowConfigService ', error);
  }
};

export const createFollowConfigService = async (payload: any) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/follow-config`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createFollowConfigService ', error);
  }
};

export const updateFollowConfigService = async (id: string, payload: any) => {
  try {
    return await http.put<any>(`/v1/ratings/follow-config/${id}`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateFollowConfigService ', error);
  }
};

export const deleteFollowConfigService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/ratings/follow-config/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteFollowConfigService ', error);
  }
};

export const restoreFollowConfigService = async (id: string) => {
  try {
    return await http.patch<any>(`/v1/ratings/follow-config/${id}/restore`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('restoreFollowConfigService ', error);
  }
};

export const getAvailableUsersForAlertsService = async (query: string = '') => {
  try {
    // Asumiendo que existe un endpoint de usuarios o lo implementarán
    // O se puede reutilizar el de getAvailableUsersRatingsService
    return await http.get<any>(`/v1/users${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getAvailableUsersForAlertsService ', error);
  }
};

export const getRatingsResumenService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/resumen`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRatingsResumenService ', error);
  }
};

export const getGoogleBusinessStatusService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/google-business`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getGoogleBusinessStatusService ', error);
  }
};

export const postGoogleCallbackService = async (code: string) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/google-business/callback`, { code });
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('postGoogleCallbackService ', error);
  }
};

export const replyGoogleBusinessReviewService = async (reviewId: string, comment: string) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/google-business/reviews/${reviewId}/reply`, {
      comment,
    });
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('replyGoogleBusinessReviewService ', error);
  }
};

export const deleteGoogleBusinessService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/ratings/google-business/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteGoogleBusinessService ', error);
  }
};

export const getGoogleBusinessReviewsStatisticsService = async (locationId?: string) => {
  try {
    const query = locationId ? `?locationId=${locationId}` : '';
    return await http.get<any>(`/v1/ratings/google-business/reviews-statistics${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getGoogleBusinessReviewsStatisticsService ', error);
  }
};

export const getGoogleBusinessResenasService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/google-business/resenas`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getGoogleBusinessResenasService ', error);
  }
};

export const getGoogleBusinessResumenService = async (locationId?: string) => {
  try {
    const query = locationId ? `?locationId=${locationId}` : '';
    return await http.get<any>(`/v1/ratings/google-business/resumen${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getGoogleBusinessResumenService ', error);
  }
};

export const getPlantillasCategoriesService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/template-answers/categories/all`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getPlantillasCategoriesService ', error);
  }
};

export const getPlantillasRespuestasService = async (locationId?: string) => {
  try {
    const query = locationId ? `?locationId=${locationId}` : '';
    return await http.get<any>(`/v1/ratings/template-answers${query}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getPlantillasRespuestasService ', error);
  }
};

export const getPlantillasRespuestasByPaginateService = async (
  page: number,
  locationId?: string
) => {
  try {
    const query = locationId ? `&locationId=${locationId}` : '';
    return await http.get<any>(`/v1/ratings/template-answers?page=` + page + query);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getPlantillasRespuestasByPaginateService ', error);
  }
};

export const getPlantillasRespuestasBySearchService = async (
  param: string,
  page: number = 1,
  locationId?: string
) => {
  try {
    const query = locationId ? `&locationId=${locationId}` : '';
    return await http.get<any>(
      `/v1/ratings/template-answers/search/` + param + `?page=` + page + query
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getPlantillasRespuestasBySearchService ', error);
  }
};

export const createPlantillaRespuestaService = async (data: any) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/template-answers`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createPlantillaRespuestaService ', error);
  }
};

export const updatePlantillaRespuestaService = async (data: any) => {
  try {
    const { id, ...payload } = data;
    return await http.put<any>(`/v1/ratings/template-answers/` + id, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updatePlantillaRespuestaService ', error);
  }
};

export const desactivePlantillaRespuestaService = async (
  id: string,
  param: string,
  page: number
) => {
  try {
    let url = `/v1/ratings/template-answers/` + id + `?page=` + page;
    if (param) url += `&param=` + param;
    return await http.delete<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('desactivePlantillaRespuestaService ', error);
  }
};

export const activePlantillaRespuestaService = async (id: string, param: string, page: number) => {
  try {
    let url = `/v1/ratings/template-answers/` + id + `/restore?page=` + page;
    if (param) url += `&param=` + param;
    return await http.patch<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('activePlantillaRespuestaService ', error);
  }
};

export const getRecurringFindingsService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/recurring-findings`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getRecurringFindingsService ', error);
  }
};

// --- Dinamic Qualification Texts ---

export const getDinamicTextsService = async () => {
  try {
    return await http.get<any>(`/v1/ratings/dinamic-qualification-texts`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getDinamicTextsService ', error);
  }
};

export const createDinamicTextService = async (data: any) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/dinamic-qualification-texts`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('createDinamicTextService ', error);
  }
};

export const updateDinamicTextService = async (id: string, data: any) => {
  try {
    return await http.put<any>(`/v1/ratings/dinamic-qualification-texts/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateDinamicTextService ', error);
  }
};

export const deleteDinamicTextService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/ratings/dinamic-qualification-texts/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteDinamicTextService ', error);
  }
};

export const restoreDinamicTextService = async (id: string) => {
  try {
    return await http.patch<any>(`/v1/ratings/dinamic-qualification-texts/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('restoreDinamicTextService ', error);
  }
};

export const postGenerateAiResponseReviewService = async (payload: any) => {
  try {
    return await http.postLogin<any>(`/v1/ratings/resumen/response-reviews`, payload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('postGenerateAiResponseReviewService ', error);
  }
};
